// @generated by protobuf-ts 2.11.1 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/enums/listing/toggle.proto" (package "bianka.enums.listing", syntax proto3)
// tslint:disable
/**
 * @generated from protobuf enum bianka.enums.listing.Toggle
 */
export enum Toggle {
    /**
     * @generated from protobuf enum value: TOGGLE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TOGGLE_PRO = 1;
     */
    PRO = 1,
    /**
     * @generated from protobuf enum value: TOGGLE_IS_ONLINE = 2;
     */
    IS_ONLINE = 2,
    /**
     * @generated from protobuf enum value: TOGGLE_SUBSCRIPTIONS = 3;
     */
    SUBSCRIPTIONS = 3,
    /**
     * @generated from protobuf enum value: TOGGLE_LOCAL_SELLERS = 4;
     */
    LOCAL_SELLERS = 4,
    /**
     * @generated from protobuf enum value: TOGGLE_AI_DELIVERY = 5;
     */
    AI_DELIVERY = 5
}
